import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { ColumnTitle } from "@sinecycle/growcomponents";
import { Empty } from "antd";
import { useAtomValue } from "jotai";
import { ProfileCards } from "../style";

const t = {
  AdditionalInformation: "Additional Information",
};

export interface AdditionalInfoCustomFieldProps {}

function AdditionalInformation(props: AdditionalInfoCustomFieldProps) {
  const config = useAtomValue(userConfigAtom);
  return (
    <ProfileCards
      title={<ColumnTitle hasSymbol>{t.AdditionalInformation}</ColumnTitle>}
    >
      {config.user_details?.customer.custom_fields?.length ? (
        <Flex vertical space={"16"}>
          {config.user_details?.customer.custom_fields.map((item) => {
            return (
              <Flex vertical space={"2"} key={item.id}>
                <TypographyText fs="12" style={{ color: "var(--gray-7)" }}>
                  {item.name}
                </TypographyText>
                <TypographyText>{item?.value}</TypographyText>
              </Flex>
            );
          })}
        </Flex>
      ) : (
        <Empty
          description="No additional info available"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
    </ProfileCards>
  );
}
export { AdditionalInformation };
